<template>
  <div class="share">
    <div class="share-shadow" @click="hideSharePopup"></div>
    <div class="share-main">
      <p class="dialog-title">{{ letter.share }}</p>
      <div class="share-group">
        <div class="share-btn" @click="shareFacebook">
          <a href="javascript:;" class="facebook"></a>
          <p class="share-btn-text">Facebook</p>
        </div>
        <div class="share-btn" @click="shareTwitter">
          <a href="javascript:;" class="twitter"></a>
          <p class="share-btn-text">X</p>
        </div>
        <div class="share-btn" @click="shareLine">
          <a href="javascript:;" class="line"></a>
          <p class="share-btn-text">LINE</p>
        </div>
        <div class="share-btn" @click="shareVk">
          <a href="javascript:;" class="vk"></a>
          <p class="share-btn-text">VK</p>
        </div>
        <div class="share-btn" @click="shareNaver">
          <a href="javascript:;" class="naver"></a>
          <p class="share-btn-text">naver</p>
        </div>
        <div
          v-if="shareSystemInst && shareSystemInst.isSupport()"
          class="share-btn"
          @click="shareSystem"
        >
          <a href="javascript:;" class="more"></a>
          <p class="share-btn-text">More</p>
        </div>
      </div>
      <Icon class="close-btn" name="close" @click="hideSharePopup"></Icon>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import {
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'sharePopup',
  props: {
    shareLimitList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      shareFacebookInst: null,
      shareTwitterInst: null,
      shareLineInst: null,
      shareVkInst: null,
      shareNaverInst: null,
      shareSystemInst: null,

      shareList: [],
      shareUrl: ''
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      gameId: state => state.gameId,
      shareFbAppId: state => state.shareFbAppId
    })
  },
  methods: {
    shareFilter(type) {
      if (!this.shareLimitList.length) {
        return true;
      }
      return this.shareLimitList.includes(type?.toLowerCase());
    },
    sharePoint(eventName, eventType, eventReason, eventValue) {
      window.webstorev35DataLayer.push({
        eventName: eventName || '',
        eventType: eventType || '',
        eventReason: eventReason,
        eventValue: eventValue || ''
      });
    },
    hideSharePopup() {
      this.$emit('closeSharePopup');
    },
    shareSystem() {
      this.sharePoint('share_channel', '更多（系统分享)', popupType.sharePopup);
      this.shareSystemInst.share();
    },
    // Facebook分享
    shareFacebook() {
      this.sharePoint('share_channel', 'Facebook', popupType.sharePopup);
      this.shareFacebookInst.share();
    },
    // Twitter分享
    shareTwitter() {
      this.sharePoint('share_channel', 'Twitter', popupType.sharePopup);
      this.shareTwitterInst.share();
    },
    // Line分享
    shareLine() {
      this.sharePoint('share_channel', 'Line', popupType.sharePopup);
      this.shareLineInst.share();
    },
    // vk分享
    shareVk() {
      this.sharePoint('share_channel', 'VK', popupType.sharePopup);
      this.shareVkInst.share();
    },
    // Naver分享
    shareNaver() {
      this.sharePoint('share_channel', 'Naver', popupType.sharePopup);
      this.shareNaverInst.share();
    },
    //分享初始化，构建实例
    initShare() {
      this.shareUrl = globalGetShareLink({
        gameId: this.gameId
      });
      this.shareFacebookInst = new ShareFacebook(this.shareFbAppId);
      this.shareSystemInst = new ShareSystem();
      this.shareTwitterInst = new ShareTwitter();
      this.shareLineInst = new ShareLine();
      this.shareNaverInst = new ShareNaver();
      this.shareVkInst = new ShareVk();

      this.initShareSetting();

      // 设置title
      this.shareFacebookInst.setTitle(this.letter.firstPayOff);
      this.shareNaverInst.setTitle(this.letter.firstPayOff);

      // 设置分享链接
      this.shareFacebookInst.setUrl(this.shareUrl + '&cid=share&scid=facebook');
      this.shareSystemInst.setUrl(this.shareUrl + '&cid=share&scid=other');
      this.shareTwitterInst.setUrl(this.shareUrl + '&cid=share&scid=twitter');
      this.shareLineInst.setUrl(this.shareUrl + '&cid=share&scid=line');
      this.shareNaverInst.setUrl(this.shareUrl + '&cid=share&scid=naver');
      this.shareVkInst.setUrl(this.shareUrl + '&cid=share&scid=vk');
    },
    // 批量配置
    initShareSetting() {
      this.shareList = [
        this.shareFacebookInst,
        this.shareSystemInst,
        this.shareTwitterInst,
        this.shareLineInst,
        this.shareNaverInst,
        this.shareVkInst
      ];
      this.shareList.forEach(item => {
        item.setContent(this.letter.firstPayOff);
        item.setPointsInfo(this.gameId, 'officialTopup');
        // 分享成功的回调
        item.setShareSuccessCallback((...args) => {
          if (this.shareFilter(item?.pointName)) {
            this.$emit('shareSuccess', item?.pointName);
          }
          this.sharePoint('share_result', item?.pointName, true);
        });
        // 分享失败的回调
        item.setShareFailCallback(
          (
            errorMsg, // 错误信息
            socialType, // 分享类型
            ...args // 其它参数
          ) => {
            this.sharePoint('share_result', item?.pointName, false, errorMsg);
          }
        );
      });
    }
  },
  mounted() {
    this.initShare();
    showPopup(popupType.sharePopup);
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.share {
  z-index: 13;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  &-main {
    text-align: center;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 20px;

    .share-group {
      min-height: 392px;
      width: 720px;
      box-sizing: border-box;
      padding: 30px 40px;

      .share-btn {
        margin: 0 14px 69px;
        display: inline-block;
        width: 100px;
        height: 100px;
        text-align: center;
        position: relative;

        .share-btn-text {
          font-size: 18px;
          color: #333333;
          margin-top: 10px;
        }
      }

      $shareList: facebook, twitter, kakao, line, vk, naver, more;
      @each $item in $shareList {
        .#{$item} {
          width: 100px;
          height: 100px;
          line-height: 150px;
          background: url($commonImg + '#{$item}_btn.png') no-repeat;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          display: inline-block;
        }
      }

      a {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
